import { createSlice } from '@reduxjs/toolkit';

const initialState = {
   organization: null,
   organizationId: null,
   programId: import.meta.env.VITE_DEFAULT_PROGRAM_ID,
   program: {
      label: 'General Fund',
      value: import.meta.env.VITE_DEFAULT_PROGRAM_ID,
      slug: ''
   },
   heroPhotos: [],
};

const setOrganization = (state: any, action: any) => {
   const isNewOrg = state.organization?.id !== action.payload?.id;
   state.organization = action.payload;
   if (isNewOrg) {
      state.programId = null;
      state.program = null;
   }
};

const resetOrganization = (state: any) => {
   state.organization = null;
};

const setOrgCookie = (state: any, action: any) => {
   state.organizationId = action.payload;
};

const setProgramId = (state: any, action: any) => {
   state.programId = action.payload;
};
const setProgram = (state: any, action: {payload: object}) => {
   state.program = action.payload;
};
const setHeroPhotos = (state: any, action: { payload: any[] }) => {
   state.heroPhotos = action.payload;
};

export const orgSlice = createSlice({
   name: 'organization',
   initialState,
   reducers: {
      setOrganization,
      resetOrganization,
      setOrgCookie,
      setProgramId,
      setProgram,
      setHeroPhotos
   },
});

export default orgSlice;
